module.exports = __webpack_public_path__ + "img/关于我们banner@2x.ab4a628e.png";